<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="规则类型">
          <ElSelect v-model="type" style="width: 120px" transfer>
            <el-option :value="-1" label="不限"></el-option>
            <el-option :value="1" label="暂停计划"></el-option>
            <el-option :value="2" label="启用计划"></el-option>
            <el-option :value="3" label="更改预算"></el-option>
            <el-option :value="4" label="更改出价"></el-option>
            <el-option :value="8" label="删除计划"></el-option>
            <el-option :value="9" label="复制计划"></el-option>
            <el-option :value="5" label="仅消息提醒"></el-option>
            <!-- <el-option :value="6" label="智能模型"></el-option> -->
            <el-option :value="7" label="智能模型2"></el-option>
            <el-option :value="10" label="智能模型3"></el-option>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="创建人">
          <ThrottleSelector
            v-model="agentId"
            @change="sendEvent"
            style="width: 120px"
            :list="SYS_USERS"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>
        <ElFormItem label="媒体">
          <ElSelect v-model="media" style="width: 120px">
            <el-option :value="-1" label="不限"></el-option>
            <el-option :value="10" label="巨量引擎"></el-option>
            <el-option :value="16" label="腾讯"></el-option>
            <el-option :value="32" label="磁力引擎"></el-option>
            <el-option :value="45" label="百度信息流"></el-option>
            <el-option :value="6" label="超级汇川"></el-option>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label-width="38">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="open">新建自动规则</ElButton>
          <ElButton @click="betchChange">批量选择账号计划</ElButton>
          <ElButton @click="$emit('remove-rows')">批量删除</ElButton>
          <slot name="gdt-auth"></slot>
        </ElFormItem>
      </ElForm>
    </div>
    <!-- :media="media" -->
    <select-modal
      v-model="model"
      :data="accounData"
      :include-data="includeData"
      :exclude-data="excludeData"
      :loading="preload"
      :asyning="saving"
      :media="selMedia"
      :plan-ids="[]"
      :exclude-plan-ids="[]"
      :lock-len="lockLen"
      :plan-len="planLen"
      :exclude-plan-len="excludePlanLen"
      @on-select="selectAll"
      @on-change="uploadPlanIds"
    />
  </div>
</template>
<script>
import { isArray, findCheckChild, getIdOfData, timeout } from '@/common/js/utils'
import { adAccount } from '@/api/common.model'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { batchAddRulePlanId } from '@/api/manage.model'
import SelectModal from './selecter/select-modal'
import { initPageData, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])
export default {
  name: 'monitorFilter',
  components: { SelectModal, ThrottleSelector },
  props: {
    selectionRow: {
      type: Array
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    selMedia() {
      const selectR = isArray(this.selectionRow) && this.selectionRow.length && this.selectionRow[0].mediaId
      if (selectR) return this.selectionRow[0].mediaId
      else return 10
    },
    lockLen() {
      return this.accounData.filter((ret) => ret.check).length
    },
    planLen() {
      return findCheckChild(this.includeData).filter((ret) => ret.plan).length
    },
    excludePlanLen() {
      return findCheckChild(this.excludeData).filter((ret) => ret.plan).length
    }
  },
  methods: {
    buildParams() {
      const params = {
        mediaId: this.media === -1 ? undefined : this.media,
        type: this.type === -1 ? undefined : this.type,
        opId: this.agentId === '' ? undefined : this.agentId,
        keyWord: this.keyword === '' ? undefined : this.keyword
      }
      return params
    },
    sendEvent() {
      const params = this.buildParams()
      this.$emit('on-change', params)
    },
    search() {
      const params = this.buildParams()
      this.$emit('on-search', params)
    },
    open() {
      this.$router.push({ name: 'monitoradd' })
    },
    getMediaAccountData() {
      this.preload = true
      adAccount({ mediaId: this.selMedia, authFlag: 1 })
        .then((accounData) => {
          this.preload = false
          if (isArray(accounData)) {
            const wrapAccount = (ret) => {
              return { id: ret.id, name: ret.name, value: ret.name, children: [], xhr: false }
            }
            this.accounData = accounData.map(wrapAccount)
            this.includeData = accounData.map(wrapAccount)
            this.excludeData = accounData.map(wrapAccount)
            this.model = true
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },

    betchChange() {
      this.getMediaAccountData()
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      setAllChecked(data, check)
    },
    uploadPlanIds() {
      const accouts = this.accounData.filter((ret) => ret.check).map((ret) => ret.id)
      const include = findCheckChild(this.includeData)
        .filter((ret) => ret.plan)
        .map((ret) => ret.id)
      const exclude = findCheckChild(this.excludeData)
        .filter((ret) => ret.plan)
        .map((ret) => ret.id)

      this.saving = true
      batchAddRulePlanId({
        ruleIds: this.selectionRow.map((ret) => ret.id),
        lockAcountIds: accouts,
        planIds: include,
        excludePlanIds: exclude
      })
        .then((data) => {
          this.saving = false
          if (data) {
            this.model = false
            this.$Message.success({
              closable: true,
              duration: 2,
              content: '更新成功！'
            })
            timeout(2000).then(() => {
              this.$emit('on-refresh')
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    }
  },
  watch: {
    media(nVal) {
      this.sendEvent()
    },
    type(nVal) {
      this.sendEvent()
    }
  },
  data() {
    return {
      model: null,
      preload: null, // 加载账号
      saving: null, // 操作修改
      keyword: '',
      media: -1,
      type: -1,
      agentId: '',
      agentData: [],
      accounData: [],
      includeData: [],
      excludeData: []
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
